import { render, staticRenderFns } from "./crop.vue?vue&type=template&id=2f5bab20&scoped=true&"
import script from "./crop.vue?vue&type=script&lang=js&"
export * from "./crop.vue?vue&type=script&lang=js&"
import style0 from "./crop.vue?vue&type=style&index=0&id=2f5bab20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5bab20",
  null
  
)

export default component.exports